'use strict';
module.exports = function () {
	$('#mySidenav .closebtn').on('click', function () {
		document.getElementById('mySidenav').style.width = '0';
		$('.overlay-background').hide();
	});

	$('.header-login a').on('click', function () {
		let registeredUser = $('.user-message.header-icon-label.user-name').data('registered');
		if (registeredUser === null) {
			document.getElementById('mySidenav').style.width = '341px';
			$('.overlay-background').show();
		}
	});

	$('#mySidenav').on('mouseleave', function () {
		document.getElementById('mySidenav').style.width = '0';
		$('.overlay-background').hide();
	});
};
